import { create } from 'zustand';
import type { CalendarTask } from '@/shared/types/database.types';

interface CalendarState {
  selectedDate: Date;
  selectedTask: CalendarTask | null;

  setSelectedDate: (date: Date) => void;
  setSelectedTask: (task: CalendarTask | null) => void;
  clearForOrgSwitch: () => void;
}

export const useCalendarStore = create<CalendarState>((set) => ({
  selectedDate: new Date(),
  selectedTask: null,

  setSelectedDate: (date) => set({ selectedDate: date }),
  setSelectedTask: (task) => set({ selectedTask: task }),
  clearForOrgSwitch: () => set({ selectedDate: new Date(), selectedTask: null }),
}));
